var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    {
      staticClass: "mb-0",
      class: _vm.inputClass,
      attrs: {
        label: _vm.labelIsHtml ? null : _vm.inputLabel,
        "label-for": _vm.inputId,
        invalidFeedback: _vm.invalidFeedback,
        state: _vm.state
      },
      scopedSlots: _vm._u(
        [
          _vm.labelIsHtml
            ? {
                key: "label",
                fn: function() {
                  return [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.inputLabel) }
                    })
                  ]
                },
                proxy: true
              }
            : null
        ],
        null,
        true
      )
    },
    [
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-form-input", {
            attrs: {
              id: _vm.inputId,
              disabled: _vm.disabled,
              placeholder: _vm.placeholder,
              required: _vm.required,
              tabindex: _vm.tabIndex,
              autocomplete: "off",
              type: "text"
            },
            on: {
              input: function($event) {
                return _vm.onChange()
              },
              keydown: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown"
                    ])
                  ) {
                    return null
                  }
                  return _vm.onArrowDown.apply(null, arguments)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "up", 38, $event.key, [
                      "Up",
                      "ArrowUp"
                    ])
                  ) {
                    return null
                  }
                  return _vm.onArrowUp.apply(null, arguments)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.onEnter.apply(null, arguments)
                }
              ],
              click: function($event) {
                return _vm.onClick()
              }
            },
            model: {
              value: _vm.inputValue,
              callback: function($$v) {
                _vm.inputValue = $$v
              },
              expression: "inputValue"
            }
          }),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOpen,
                  expression: "isOpen"
                }
              ],
              staticClass: "autocomplete-elements",
              class: {
                "autocomplete-elements-hidden":
                  _vm.elements.length === 0 &&
                  !(
                    _vm.inputValue &&
                    _vm.needCreateIfEmpty &&
                    _vm.inputValue.trim() !== ""
                  )
              },
              attrs: { id: "autocomplete-elements" }
            },
            [
              _vm._l(_vm.elements, function(element, i) {
                return _c(
                  "li",
                  {
                    key: i,
                    staticClass: "autocomplete-element",
                    class: { "is-active": i === _vm.arrowCounter },
                    on: {
                      click: function($event) {
                        return _vm.setElement(element)
                      }
                    }
                  },
                  [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(element.formattedText) }
                    })
                  ]
                )
              }),
              _vm._v(" "),
              _vm.needCreateIfEmpty &&
              _vm.inputValue &&
              _vm.elements.length === 0 &&
              _vm.inputValue.trim() !== ""
                ? _c(
                    "li",
                    {
                      staticClass: "autocomplete-element create-new",
                      on: { click: _vm.createNewItem }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("Create")) +
                          ' "' +
                          _vm._s(_vm.inputValue) +
                          '"\n      '
                      )
                    ]
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60fabe74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60fabe74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/b122/editFields/AutocompleteField.vue
// module id = oAcC
// module chunks = 0